module.exports = {
	"config": {
		"default": {
			"title": "Dinarte Jesus",
			"description": "Welcome to my place on the web, I'm a web developer passionate about web and startups"
		},
		"linkPrefix": "/",
		"googleAnalytics": "UA-88597333-1",
		"social": [
			"http://twitter.com/jdinartejesus",
			"http://github.com/jdinartejesus",
			"http://linkedin.com/in/jdinartejesus"
		]
	},
	"relativePath": "",
	"pages": [
		{
			"file": {
				"root": "",
				"dir": "",
				"base": "_template.jsx",
				"ext": "jsx",
				"name": "_template",
				"extname": ".jsx",
				"basename": "_template.jsx",
				"dirname": "",
				"stem": "_template",
				"path": "_template.jsx",
				"absolute": "/Users/dinartejesus/develop/projects/jdinartejesus.github.io/_template.jsx",
				"isAbsolute": false
			},
			"requirePath": "_template.jsx",
			"templatePath": "//",
			"data": {}
		},
		{
			"file": {
				"root": "",
				"dir": "",
				"base": "404.jsx",
				"ext": "jsx",
				"name": "404",
				"extname": ".jsx",
				"basename": "404.jsx",
				"dirname": "",
				"stem": "404",
				"path": "404.jsx",
				"absolute": "/Users/dinartejesus/develop/projects/jdinartejesus.github.io/404.jsx",
				"isAbsolute": false
			},
			"requirePath": "404.jsx",
			"path": "/404.html",
			"data": {
				"title": "ups 404, NOT FOUND",
				"path": "/404.html"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "",
				"base": "index.jsx",
				"ext": "jsx",
				"name": "index",
				"extname": ".jsx",
				"basename": "index.jsx",
				"dirname": "",
				"stem": "index",
				"path": "index.jsx",
				"absolute": "/Users/dinartejesus/develop/projects/jdinartejesus.github.io/index.jsx",
				"isAbsolute": false
			},
			"requirePath": "index.jsx",
			"path": "/",
			"data": {}
		}
	]
}


//////////////////
// WEBPACK FOOTER
// ../config.toml
// module id = 382
// module chunks = 0